import React from "react";
import InputField from "../../../../components/InputField";
import DocumentUpload from "../../../../components/DocumentUpload";
import "./index.scss";

const GSTEntries = ({
  isGSTRegistered,
  gstEntries,
  addGstEntry,
  removeGstEntry,
  handleGstChange,
  handleGstBlur,
  gstFiles,
  handleGstFileChange,
  gstErrors,
  existingGstFiles = [],
  gstCertErrors = {},
  onGstFileChange,
  deficiencyMap = {},
  isDeficiencyMode = false,
}) => {
  if (isGSTRegistered !== "yes") return null;

  return (
    <div className="gst-entries">
      {gstEntries.map((entry, index) => {
        const certKey = `gst_file_${index}`;
        const isDeficient = !!deficiencyMap[certKey];
        const uploadable = !isDeficiencyMode || isDeficient;

        return (
          <div key={index} className="gst-entry-row">
            <InputField
              name={`gstNumber_${index}`}
              label="GST Number"
              type="text"
              placeholder="e.g. 22AAAAA0000A1Z5"
              value={entry.gstNumber}
              maxLength={15}
              onChange={(e) =>
                handleGstChange &&
                handleGstChange(index, "gstNumber", e.target.value)
              }
              onBlur={() => handleGstBlur && handleGstBlur(index)}
              error={gstErrors[index] || ""}
              required
            />
            <InputField
              name={`gstState_${index}`}
              label="State"
              type="text"
              placeholder="Auto-filled from GST number"
              value={entry.gstState}
              readOnly
            />
            <InputField
              name={`gstAddress_${index}`}
              label="GST Address"
              type="text"
              placeholder="Enter GST address"
              value={entry.gstAddress}
              onChange={(e) =>
                handleGstChange &&
                handleGstChange(index, "gstAddress", e.target.value)
              }
            />
            {/* GST Certificate upload — highlighted red when deficient */}
            <div className={isDeficient ? "doc-deficient-wrap" : ""}>
              <DocumentUpload
                label="GST Certificate"
                name={`gstCertificate_${index}`}
                file={gstFiles[index]}
                existingFile={existingGstFiles[index] || null}
                required
                error={gstCertErrors[`gst_certificate_${index}`] || ""}
                disabled={!uploadable}
                onChange={(e) => {
                  if (!uploadable) return;
                  const file = e.target.files[0];
                  handleGstFileChange(index, file);
                  if (onGstFileChange) onGstFileChange(index, file);
                }}
              />
              {isDeficient && (
                <span className="doc-deficient-label">
                  ⚠ Deficiency — please re-upload
                </span>
              )}
            </div>
            {gstEntries.length > 1 && !isDeficiencyMode && (
              <button
                type="button"
                className="btn-remove-gst"
                onClick={() => removeGstEntry && removeGstEntry(index)}
              >
                ✕
              </button>
            )}
          </div>
        );
      })}
      {!isDeficiencyMode && (
        <button type="button" className="btn-add-gst" onClick={addGstEntry}>
          + Add GST
        </button>
      )}
    </div>
  );
};

export default GSTEntries;
